export default "__VITE_ASSET__3e6e2cf0__"